import AccordionItem from 'app/modules/tickets/drawer/components/AccordionItem'
import { DatePackageAvailable, PackageAvailableCalendarResponse, SPAvaialble } from 'app/modules/tickets/models/OrderDrawerModel'
import { TimeSlotPackage } from 'shared/DateTimeVisitTable'
import { classNameFunc } from 'app/utils/helpers/components/Form'
import { Field } from 'formik'
import moment from 'moment'
import { SyntheticEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DateTimePickerInline } from 'shared/DateTime'
import { TSelectedPackageItem } from 'shared/DateTimeVisitTable'
import DateTimeVisitTable from 'shared/DateTimeVisitTable/DateTimeVisitTable'
import {DateTimeReschedule} from './type'
import {RescheduleTicketRequest} from 'app/modules/tickets/models/RescheduleTicket'
import {toast} from 'react-toastify'
import {ToastDefaultConfig} from 'setup/toast/ToastConfig'
import {clientTimeZoneOffset, DEFAULT_WORKER} from 'app/utils/common/constants'
import './DateTime.scss'
import { KTSVG } from 'app/utils/helpers'
import {
  applySlotDisplayWindow,
  pickRouteOptimizationCfg,
} from 'app/utils/helpers/OrderDrawerHelpers'
import {
  buildRescheduleDayRequest,
  fetchRescheduleCalendarDays,
  fetchRescheduleSlots,
  resolveProviderSlotContext,
} from 'app/modules/tickets/redux/RescheduleAvailability'
import {
  computeCalendarDelta,
  mergeCalendarDays,
  mergeWorkerDayLists,
} from 'app/modules/tickets/redux/PackageAvailabilityV2'
import { ReschedulePackageForm } from '../type'
import { useAppSelector } from 'setup/redux/Hooks'
import { selectTicketModalData } from 'app/modules/tickets/redux/TicketSlice'

const DateTimeSection = ({
  ticketId,
  number_visit,
  number_week,
  scheduledVisitDateTime,
  form,
  language,
}: DateTimeReschedule) => {
  const { t } = useTranslation()
  const { setValues, validateField, setFieldTouched, values } = form

  const oldDate = scheduledVisitDateTime && new Date(scheduledVisitDateTime)

  const touched = form?.touched['date_time']
  let _error = form?.errors['date_time']
  if (Array.isArray(_error)) {
    _error = _error.filter((e) => e !== undefined && e !== null)[0]
  }
  let [error, params = ''] = ![null, undefined, ''].includes(_error as any)
    ? String(typeof _error == 'object' ? Object.entries(_error).map((e) => e[1])[0] : _error).split(
      '-'
    )
    : [_error, '']
  error = ![null, undefined, ''].includes(error as any)
    ? t(error as string).format(params.split(';'))
    : error

  const isInvalid = touched !== false && touched !== undefined && error !== undefined

  const [cursor, setCursor] = useState<Date | undefined>()
  const [minDate, setMinDate] = useState<Date | undefined>(new Date())
  const [openToDate, setOpenToDate] = useState<Date | undefined>(new Date().addDays(1))
  const [selected, setSelected] = useState<TSelectedPackageItem[] | undefined>([])
  const [excludeDates, setExcludeDates] = useState<DatePackageAvailable[]>([])
  const [isPending, setIsPending] = useState<boolean>(false)
  const [isExistedVisit, setIsExistedVisit] = useState<boolean>(false)
  const [numberVisitExist, setNumberVisitExist] = useState<number>(1)
  const [listSPAvailable, setListSPAvailable] = useState<SPAvaialble[]>([])
  const [isUnavaiableDate, setIsUnavaiableDate] = useState<boolean>(false)
  const [mergedAvailableDays, setMergedAvailableDays] = useState<DatePackageAvailable[]>([])
  const [lastCalendar, setLastCalendar] = useState<PackageAvailableCalendarResponse | null>(null)
  const [extraMonthDays, setExtraMonthDays] = useState<DatePackageAvailable[]>([])
  const [isMonthLoading, setIsMonthLoading] = useState<boolean>(false)

  const ticketDetail = useAppSelector(selectTicketModalData);
  const spIdOrg = ticketDetail?.spId;

  // Day list for the current selection (pure): the selected worker's own calendar, or the
  // pooled view merged across all providers ("Based on Availability").
  const deriveDayContext = () => {
    const isWorkerSelected =
      !!values.service_provider && values.service_provider !== DEFAULT_WORKER
    if (isWorkerSelected) {
      const selectedWorker = values.service_provider_available.find(
        (el) => el.workerId === values.service_provider
      )
      return {
        isWorkerSelected,
        selectedWorker,
        dayList: selectedWorker?.listAvailableDay || [],
        mergedPooledDays: [] as DatePackageAvailable[],
      }
    }
    const mergedPooledDays = mergeWorkerDayLists([
      values.defaultServiceProvider?.listAvailableDay,
      ...(values.service_provider_available || []).map((w) => w?.listAvailableDay),
    ])
    return {
      isWorkerSelected,
      selectedWorker: values.defaultServiceProvider,
      dayList: mergedPooledDays,
      mergedPooledDays,
    }
  }

  // Reset the date/slot selection whenever the day-list source changes (worker, filter, reload).
  useEffect(() => {
    setFieldTouched('date_time', false)
    setSelected([])
    setCursor(undefined)
    setExcludeDates([])
    setExtraMonthDays([]) // base day list changed; month-navigation pages no longer apply
    setIsExistedVisit(false)
    setValues((s) => ({...s, date_time: undefined}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    setFieldTouched,
    setValues,
    spIdOrg,
    values.service_provider,
    values.loadingType,
    values.service_provider_available,
  ])

  // Derive and apply the visible day list: merged pooled days, picker bounds, and the
  // provider context (newSpId, visit reminder, route-opt cfg, filter start date).
  useEffect(() => {
    const {isWorkerSelected, selectedWorker, dayList, mergedPooledDays} = deriveDayContext()

    setMergedAvailableDays(isWorkerSelected ? [] : mergedPooledDays)

    const firstAvailable = dayList.find((e) => e.isAvailable)
    // Worker view opens on the worker's first listed day; pooled view on the earliest
    // available day. Without any available day the picker starts from tomorrow.
    const pickerStart = !firstAvailable
      ? new Date().addDays(1)
      : isWorkerSelected
      ? new Date(dayList[0].dateCheck)
      : new Date(firstAvailable.dateCheck)
    setOpenToDate(pickerStart)
    setMinDate(pickerStart)

    setValues((s) => {
      const updates: Partial<ReschedulePackageForm> = {
        newSpId: spIdOrg || '',
        visitReminder: selectedWorker?.visitReminder ?? '',
        routeOptimizationCfg:
          pickRouteOptimizationCfg(selectedWorker) ?? s.routeOptimizationCfg,
      }

      if ((s.service_provider === DEFAULT_WORKER || !s.service_provider) && firstAvailable) {
        const earliestDate = new Date(firstAvailable.dateCheck)
        updates.service_provider_filter = {
          ...s.service_provider_filter,
          startDate: earliestDate,
        }
        updates.filterStartDate = earliestDate
        if (s.defaultServiceProvider) {
          updates.defaultServiceProvider = {
            ...s.defaultServiceProvider,
            startDate: earliestDate,
          }
        }
      }

      return {
        ...s,
        ...updates,
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    setFieldTouched,
    setValues,
    spIdOrg,
    values.service_provider,
    values.loadingType,
    values.service_provider_available,
  ])

  useEffect(() => {
    if (
      (values.service_provider === DEFAULT_WORKER || !values.service_provider) &&
      mergedAvailableDays.length > 0 &&
      values.defaultServiceProvider &&
      values.service_provider_available &&
      values.service_provider_available.length > 0
    ) {
      const firstAvailableFromMerged = mergedAvailableDays.find((e) => e.isAvailable)
      if (firstAvailableFromMerged) {
        const earliestDate = new Date(firstAvailableFromMerged.dateCheck)
        const currentStartDate = values.defaultServiceProvider.startDate
        const currentStartDateStr = currentStartDate 
          ? new Date(currentStartDate).toISOString().split('T')[0]
          : null
        const earliestDateStr = earliestDate.toISOString().split('T')[0]
        
        if (currentStartDateStr !== earliestDateStr) {
          setValues((s) => {
            // Double-check to avoid infinite loop - only update if startDate is different
            const existingStartDate = s.defaultServiceProvider?.startDate
            const existingStartDateStr = existingStartDate 
              ? new Date(existingStartDate).toISOString().split('T')[0]
              : null
            
            if (existingStartDateStr === earliestDateStr) {
              return s
            }
            
            return {
              ...s,
              service_provider_filter: {
                ...s.service_provider_filter,
                startDate: earliestDate,
              },
              filterStartDate: earliestDate,
              defaultServiceProvider: s.defaultServiceProvider
                ? {
                    ...s.defaultServiceProvider,
                    startDate: earliestDate,
                  }
                : s.defaultServiceProvider,
            }
          })
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mergedAvailableDays, values.service_provider, values.service_provider_available, setValues])

  interface DateAvailableResult {
    calendar: PackageAvailableCalendarResponse | null
    availableDay?: DatePackageAvailable
    visitReminder?: string
  }

  const getDateAvailable = async (
    req: RescheduleTicketRequest,
    date: Date
  ): Promise<DateAvailableResult | undefined> => {
    try {
      const { calendar, availableDay, visitReminder } = await fetchRescheduleSlots(req, date)
      return { calendar, availableDay, visitReminder }
    } catch (error) {
      console.log(error)
      return
    }
  }

  const buildRescheduleReq = (date: Date): RescheduleTicketRequest => {
    return {
      ticketId,
      selectedDateString: moment(date).locale('en-US').format('MM/DD/YYYY'),
      shiftType: values.service_provider_filter.filterBy,
      selectWorkerId:
        values.service_provider && values.service_provider !== DEFAULT_WORKER
          ? values.service_provider
          : '',
      clientTimeOffset: -clientTimeZoneOffset,
    }
  }

  /**
   * Each bus renders only its OWN in-hours slots — available or disabled (CB-2516).
   * The backend sends every bus its full own-hours grid, so never pad a bus's list
   * with the day union: that leaks other clusters' out-of-hours slots into its row.
   */
  const normalizeSpTimeSlots = (spList: SPAvaialble[]): SPAvaialble[] => {
    if (!spList || spList.length === 0) return []

    return spList.map((sp) => ({
      ...sp,
      listTimes: [...(sp.listTimes || [])].sort((a, b) => (a.start ?? 0) - (b.start ?? 0)),
    }))
  }

  const onChangeMonth = async (displayedMonth: Date) => {
    const delta = computeCalendarDelta(displayedMonth, values.calendarLoadedUntilDay)
    if (!delta) return
    setIsMonthLoading(true)
    try {
      const workerSelected =
        values.service_provider && values.service_provider !== DEFAULT_WORKER
      const {days} = await fetchRescheduleCalendarDays(
        buildRescheduleDayRequest(
          {
            ticketId,
            shiftType: values.service_provider_filter.filterBy,
            clientTimeOffset: -clientTimeZoneOffset,
            selectWorkerId: workerSelected ? values.service_provider! : '',
          },
          undefined,
          delta.limitDays,
          delta.startDay
        )
      )
      setExtraMonthDays((prev) => mergeCalendarDays(prev, days))
      setValues((s) => ({...s, calendarLoadedUntilDay: delta.requiredDays}))
    } catch (error) {
      console.log(error)
    } finally {
      setIsMonthLoading(false)
    }
  }

  const handleDateChange = async (date?: Date | null, event?: SyntheticEvent<any> | undefined) => {
    if (date === undefined || date === null) return

    void onChangeMonth(date)

    let newCursor = date
    let isExistVisit = isExistedVisit
    let numberExitVisit = numberVisitExist
    let checkAvailableDate = false

    try {
      setIsPending(true)
      const resp = await getDateAvailable(buildRescheduleReq(date), date)
      if (!resp) {
        toast.error(`${t('ERROR_MESSAGE.DATE_TIME_ERROR.UNEXPECTED_ERROR')}`, ToastDefaultConfig())
        setIsPending(false)
        return
      }

      const availableDate: DatePackageAvailable | undefined = resp.availableDay
      let selectedSpIdForDate = values.newSpId || spIdOrg || ''

      setLastCalendar(resp.calendar)

      // Keep the current bus if it has a slot on this date, else pick the first that does.
      const providers = availableDate?.spAvaialble || []
      const hasAvailableSlot = (sp: SPAvaialble) => (sp.listTimes || []).some((s) => s.isAvailable)
      const currentKey = (values.newSpId || spIdOrg || '').toUpperCase()
      const current = providers.find((p) => (p.spId || '').toUpperCase() === currentKey)
      if (!(current && hasAvailableSlot(current))) {
        selectedSpIdForDate =
          providers.find(hasAvailableSlot)?.spId ?? providers[0]?.spId ?? selectedSpIdForDate
      }

      const ctx = resolveProviderSlotContext(resp.calendar, selectedSpIdForDate || spIdOrg, {
        routeOptimizationCfg: values.routeOptimizationCfg ?? null,
        visitReminder: resp.visitReminder ?? values.visitReminder,
        ticketSpId: spIdOrg,
        ticketCfg: ticketDetail?.routeOptimizationCfg,
      })
      const routeOptimizationCfg = ctx.routeOptimizationCfg
      const visitReminder = ctx.visitReminder

      setValues((s) => ({
        ...s,
        visitReminder,
        routeOptimizationCfg,
      }))

      //Disabled date is not available
      let arrayInActiveDate = [...excludeDates]
      if (!availableDate) {
        isExistVisit = false;
        if (values.service_provider === '0') checkAvailableDate = true;
        setIsPending(false);
      }
      else {
        //Show warning same day visit
        isExistVisit = availableDate.isExistedVisit ?? false
        if (oldDate && new Date(newCursor).isSame(oldDate)) {
          if (availableDate.numberVisit && availableDate.numberVisit <= 1) isExistVisit = false
          else numberExitVisit = availableDate.numberVisit ?? 1
        }
        else {
          numberExitVisit = availableDate.numberVisit ? parseInt(`${availableDate.numberVisit + 1}`) : 2
        }
      }

      // One spAvaialble entry per bus, each carrying only its own in-hours slots.
      let listSp = normalizeSpTimeSlots(availableDate?.spAvaialble || [])

      if (listSp?.length) {
        listSp = listSp.map((sp) => ({
          ...sp,
          listTimes: applySlotDisplayWindow(
            sp.listTimes || [],
            sp.routeOptimizationCfg !== undefined ? sp.routeOptimizationCfg : routeOptimizationCfg,
            sp.visitReminder ?? visitReminder,
            values.isShowDeliveryTime,
          ),
        }))
      }

      // Set the normalized and processed list to state
      setListSPAvailable(listSp)

      // Use selectedSpIdForDate (found SP that has the selected date) or fallback to current newSpId
      const spIdSelected = selectedSpIdForDate || values.newSpId || (spIdOrg ?? '')
      const listTimeSlotSp = listSp?.find((x) => x.spId === spIdSelected)?.listTimes
      const timeSlot = listTimeSlotSp?.map((s, index) => ({ ...s, isSelected: false }))

      // Update newSpId if we found a different SP for this date
      if (selectedSpIdForDate && selectedSpIdForDate !== values.newSpId) {
        setValues((s) => ({
          ...s,
          newSpId: selectedSpIdForDate,
        }))
      }

      updateFormValues(
        [
          {
            date: newCursor,
            time: undefined,
            timeSlot: timeSlot,
            related: undefined,
          },
        ],
        spIdSelected
      )
      setIsExistedVisit(isExistVisit)
      setIsUnavaiableDate(checkAvailableDate)
      setNumberVisitExist(numberExitVisit)
      setCursor(newCursor)
      setOpenToDate(newCursor)
      setSelected([
        {
          date: newCursor,
          time: undefined,
          timeSlot: timeSlot,
          related: undefined,
        },
      ])
      setExcludeDates(arrayInActiveDate)
      setIsPending(false)
    } catch (error) {
      toast.error(`${t('ERROR_MESSAGE.DATE_TIME_ERROR.UNEXPECTED_ERROR')}`, ToastDefaultConfig())
      setIsPending(false)
    }
  }

  const onSelectTimeSlot = (d: Date, spId: string, e: TimeSlotPackage) => {
    if (!e.isAvailable || cursor === undefined) return

    const selectedDate = [...(selected || [])]
    const find = selectedDate.find((el) => new Date(el.date).isSame(d))
    if (find == null) return
    find.timeSlot?.forEach((slot) =>
      slot.start === e.start ? (slot.isSelected = true) : (slot.isSelected = false)
    )

    if (number_visit === 1 && number_week > 1) {
      selectedDate.forEach((item) => {
        item.time = e
      })
    } else if (number_visit > 1 && number_week >= 1) {
      selectedDate.forEach((item) => {
        if (
          (item.related && item.related.isSame(new Date(d))) ||
          (!item.related && item.date.isSame(new Date(d)))
        ) {
          item.time = e
        }
      })
    } else {
      find.time = e
    }
    setSelected(selectedDate)
    updateFormValues(selected, spId)
  }

  const onClearSelected = (date: Date, time?: TimeSlotPackage) => {
    let selectedDate = [...(selected || [])].filter((e) =>
      time === undefined ? (!e.related ? !e.date.isSame(date) : !e.related?.isSame(date)) : true
    )
    if (time !== undefined) {
      if (number_visit === 1 && number_week > 1) {
        const find =
          selectedDate.filter((e) => e.date.isSame(date) || e.related?.isSame(date)) || []
        if (find) {
          find.forEach((item) =>
            item.timeSlot?.forEach((slot) =>
              slot.start === time.start ? (slot.isSelected = false) : slot.isSelected
            )
          )
        }
        selectedDate = selectedDate.map((s) => ({
          ...s,
          time: undefined,
        }))
      } else if (number_visit > 1 && number_week >= 1) {
        const find =
          selectedDate.filter((e) => e.date.isSame(date) || e.related?.isSame(date)) || []
        if (find) {
          find.forEach((item) =>
            item.timeSlot?.forEach((slot) =>
              slot.start === time.start ? (slot.isSelected = false) : slot.isSelected
            )
          )
        }
        selectedDate = selectedDate.map((s) =>
          s.date.isSame(date) || s.related?.isSame(date)
            ? {
              ...s,
              time: undefined,
            }
            : s
        )
      } else {
        const find = selectedDate.find((e) => e.date.isSame(date))
        if (find) find.time = undefined
        find?.timeSlot?.forEach((slot) =>
          slot.start === time.start ? (slot.isSelected = false) : slot.isSelected
        )
      }
    }
    setCursor(selectedDate[0]?.date)
    setSelected(selectedDate)
    updateFormValues(selectedDate)
  }

  const onSelectedSp = (spId: string) => {
    // no pre select timeslot when selected SP
    if (spId !== values.newSpId) {
      let selectedDate = selected;
      if (selectedDate && selectedDate[0]) {
        const find = selectedDate[0]
        if (find) find.time = undefined
        find.timeSlot = undefined
      }
      setSelected(selectedDate)

      const spItem = listSPAvailable.find((s) => s.spId === spId)
      // The selected bus's cfg + reminder come from the calendar's provider entries.
      const ctx = resolveProviderSlotContext(lastCalendar, spId, {
        routeOptimizationCfg: values.routeOptimizationCfg ?? null,
        visitReminder: values.visitReminder,
        ticketSpId: spIdOrg,
        ticketCfg: ticketDetail?.routeOptimizationCfg,
      })
      const routeOptimizationCfg = ctx.routeOptimizationCfg
      const visitReminder = spItem?.visitReminder ?? ctx.visitReminder

      setValues((s) => ({
        ...s,
        newSpId: spId,
        routeOptimizationCfg,
        visitReminder,
      }))

      if (listSPAvailable.length) {
        setListSPAvailable(
          listSPAvailable.map((sp) => ({
            ...sp,
            listTimes: applySlotDisplayWindow(
              sp.listTimes || [],
              sp.routeOptimizationCfg !== undefined ? sp.routeOptimizationCfg : routeOptimizationCfg,
              sp.visitReminder ?? visitReminder,
              values.isShowDeliveryTime,
            ),
          })),
        )
      }

      updateFormValues(selectedDate, spId)
    }
  }

  const updateFormValues = (select: typeof selected, newSp?: string) => {
    if (!select || (select && select.length === 0)) {
      setIsExistedVisit(false)
    }
    setValues((s) => ({
      ...s,
      date_time: select as TSelectedPackageItem[],
      ...(newSp && { newSpId: newSp })
    }))
    validateField('date_time')
  }

  const selectDateRequired =
    number_visit === 1
      ? t('CREATE_ORDER_DRAWER.SECTION_3.NUMBER_SELECT_1_DATE')
      : number_visit === 2
        ? t('CREATE_ORDER_DRAWER.SECTION_3.NUMBER_SELECT_2_DATE')
        : t('CREATE_ORDER_DRAWER.SECTION_3.NUMBER_SELECT_MULTI_DATE', { num: number_visit })
  return (
    <AccordionItem
      id='date_time--RS'
      title={`2. ${t('RESCHEDULE_TICKET.DATE_TIME_SECTION.TITLE')}`}
    >
      <p className='section-title'>{t('CREATE_ORDER_DRAWER.SECTION_3.SUB_TITLE')}</p>
      {!(values.service_provider === null || values.service_provider === undefined) &&
        number_visit >= 1 &&
        number_week >= 1 && <span>{selectDateRequired}</span>}
      <div className={classNameFunc(isInvalid && 'has-error')}>
        {isInvalid && <p className='text-danger invalid-feedback'>{error}</p>}
      </div>
      {isExistedVisit && !isUnavaiableDate && (
        <div dir={language === 'en' ? 'ltr' : 'rtl'} className='warning-same-day'>
          <span className='warning--icon'>
            <KTSVG defaultColor={true} path='/assets/images/icons/warning.svg' />
          </span>
          <span>
            {t('RESCHEDULE_TICKET.DATE_TIME_SECTION.WARNING_SAME_DAY', {
              number_visit_exist: numberVisitExist,
            })}
          </span>
        </div>
      )}

      <div className='date-time-picker-inline-component'>
        <Field
          name='date_time'
          component={DateTimePickerInline}
          onChange={handleDateChange}
          onMonthChange={onChangeMonth}
          value={cursor}
          isLoading={values.loadingType || isPending || isMonthLoading}
          openToDate={openToDate}
          minDate={minDate}
          excludeDates={excludeDates}
          activeDates={mergeCalendarDays(
            values.service_provider && values.service_provider !== DEFAULT_WORKER
              ? values.service_provider_available.find(
                  (el) => el.workerId === values.service_provider
                )?.listAvailableDay || []
              : mergedAvailableDays.length > 0
              ? mergedAvailableDays
              : values.defaultServiceProvider?.listAvailableDay || [],
            extraMonthDays
          )}
          language={language}
          disableDate={!form.values.defaultServiceProvider}
        />
        <DateTimeVisitTable
          isLoading={isPending}
          isMulti={false}
          isEmpty={isUnavaiableDate}
          routeOptimizationCfg={values.routeOptimizationCfg}
          visitReminder={values.visitReminder}
          isShowDeliveryTime={values.isShowDeliveryTime}
          showWarning={false}
          dateTimeOptions={selected || []}
          onSelectTimeSlot={onSelectTimeSlot}
          onClearSelected={onClearSelected}
          onSelectedSp={onSelectedSp}
          lang={language}
          listSpAvailable={listSPAvailable}
          newSpId={values.newSpId}
        />
      </div>
    </AccordionItem>
  )
}

export default DateTimeSection
